// Tiny global flag used by CheckinDialog / PetDialog / CalendarSheet to
// pause background polling (App.js todayCheckins every 15s, Dashboard
// upcomingEvents every 30s) while the user is typing inside a dialog.
// Mobile Android Chrome closes the soft keyboard whenever a large parent
// re-render happens, even if the focused <textarea> DOM node is preserved.
// Pausing polls keeps the keyboard open.

import { useEffect } from "react";

const KEY = "__ffDialogOpenCount";

const getCount = () => (typeof window === "undefined" ? 0 : window[KEY] || 0);
const setCount = (v) => {
  if (typeof window === "undefined") return;
  window[KEY] = Math.max(0, v);
};

export const isDialogOpen = () => getCount() > 0;

// Hook: call from any component that shows a text input / textarea to
// suspend polling while it's mounted.
export function useSuspendPollingWhileOpen(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    setCount(getCount() + 1);
    return () => setCount(getCount() - 1);
  }, [active]);
}
